import { h } from 'preact'; /** @jsx h */

import BannerImage from '../components/olav/BannerImage/BannerImage';
import CTABlock from '../components/olav/CTABlock/CTABlock';
import Content from '../components/olav/Content/Content';
import Divider from '../components/olav/Divider/Divider';
import FactPopup from '../components/olav/FactPopup/FactPopup';
import FixedCTA from '../components/olav/FixedCTA/FixedCTA';
import FooterCTA from '../components/olav/FooterCTA/FooterCTA';
import Heading from '../components/olav/Heading/Heading';
import Hero from '../components/olav/Hero/Hero';
import Image from '../components/olav/Image/Image';
import InlineCTA from '../components/olav/InlineCTA/InlineCTA';
import Paragraph from '../components/olav/Paragraph/Paragraph';
import Quote from '../components/olav/Quote/Quote';
import Section from '../components/olav/Section/Section';
import SplitCTABox from '../components/olav/SplitCTABox/SplitCTABox';
import StickyQRCTA from '../components/olav/StickyQRCTA/StickyQRCTA';
import Video from '../components/olav/Video/Video';
import VippsBanner from '../components/olav/VippsBanner/VippsBanner';

import '../styles/olav/kampen-for-bestefars-liv.scss';

const Olav = () => {
    return (
        <div className="olav">
            <div className="gutters">
                <Hero
                    imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/10/kampen-for-bestefars-liv-hero.jpg"
                    alt=""
                >
                    <div className="sticky-tag-wrapper">
                        <div className="sticky-tag-container">
                            <span className="sticky-tag">Ingen å miste.</span>
                        </div>
                    </div>
                    <div className="emergency-stripes">
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/02/akuttstriper-vertikal-gul.svg"
                            alt="Gule akuttstriper"
                            loading="lazy"
                        />
                    </div>
                    <div className="above-fold">
                        <Heading type="h1" className="hero-title">
                            <span className="hero-title-section">
                                <span>Kampen for bestefars liv</span>
                            </span>
                        </Heading>
                    </div>
                    <div className="hero-overlay">
                        <div className="overlay-padding">
                            <Content width="small">
                                <Paragraph type="ingress" color="all-white">
                                    Brødrene Eirik (24) og Sivert (22) stikker innom foreldrene en
                                    lørdag formiddag, før de skal videre for å møte venner. Det er
                                    én av mange tilfeldigheter som klaffer den dagen bestefar Olavs
                                    hjerte slutter å slå.
                                </Paragraph>
                                <Paragraph
                                    type="byline"
                                    textAndPhoto="Marthe Berg Tvetene"
                                    video="Kim Aage Leinhardt"
                                    color="all-white"
                                />
                                <Quote animation="fade-up" color="all-white" borderColor="red">
                                    – Lasse! Jeg får ikke kontakt med pappa. Du må komme!
                                    {/* <FixedCTA
                                        color="snla-red"
                                        text="<b>Vær<br /> bedre<br /> forberedt</b>"
                                        buttonText="Last ned<br /><b>Hjelp 113</b><br />gratis"
                                        icon="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-app-icon.png"
                                        link="#hjelp-113"
                                    /> */}
                                </Quote>
                                <Paragraph type="normal" color="all-white" borderColor="red">
                                    Lasse (54) har akkurat kommet hjem fra et kaffebesøk hos
                                    foreldrene sine i nabohuset da moren ringer. Han har skiftet til
                                    arbeidstøy og er på vei ut i garasjen for å jobbe litt på bilen.
                                </Paragraph>
                                <Quote animation="fade-up" color="all-white" borderColor="red">
                                    – Sivert! Eirik! Det er bestefar, roper Lasse.
                                </Quote>
                                <Paragraph color="all-white">
                                    Sønnene Eirik (24) og Sivert (22) har flyttet hjemmefra, men er
                                    tilfeldigvis innom barndomshjemmet denne lørdag formiddagen i
                                    september.
                                </Paragraph>
                                <Quote animation="fade-up" color="all-white" borderColor="red">
                                    – Alt skjedde så fort. Jeg skulle ut og spise med noen kompiser,
                                    så jeg hadde kledd meg opp for å være ute blant folk. Så får jeg
                                    høre fra pappa at bestemor er på telefonen, og at det gjelder
                                    bestefar, sier Eirik.
                                </Quote>
                                <Paragraph color="all-white">
                                    Før han får vite noe mer, har Eirik tatt på seg skoene og er på
                                    vei ut døren. Lillebror Sivert er sekunder bak ham. De spurter
                                    de hundre meterne til besteforeldrenes hus.
                                </Paragraph>
                                <Heading type="h3" weight="600" color="all-white">
                                    Synet som møter dem er skremmende.
                                </Heading>
                                <Paragraph color="all-white">
                                    Bestefar Olav (81) ligger livløs på den vinrøde skinnsofaen. Han
                                    er blek i ansiktet og har ukontrollerte rykninger i kroppen. Det
                                    skummer fra munnen og det kommer hese lyder fra halsen, som om
                                    han prøver å puste, men ikke får det helt til.{' '}
                                </Paragraph>
                                <Paragraph color="all-white">
                                    Han svever mellom å være bevisstløs og så vidt til stede.
                                </Paragraph>
                                <Video
                                    src="https://player.vimeo.com/video/1025119360?autoplay=0&autopause=0&muted=0&loop=0&title=0&byline=0&portrait=0"
                                    padding="177.78%"
                                    height="500"
                                    caption="Video: Hør Lasse (54) fortelle om reaksjonen sin da han fikk se faren Olav bevisstløs på sofaen."
                                />
                                <Quote animation="fade-up" color="all-white" borderColor="red">
                                    – Det var sjokkerende å se bestefar ligge der. Jeg har jo hatt
                                    førstehjelpskurs, men de dukkene illustrerer ikke hvordan et
                                    ekte menneske blir liggende i det hele tatt. Det første jeg
                                    tenkte var «Hva er dette her? Må vi gjøre hjertekompresjoner
                                    eller har han svelget feil og blir kvelt av noe?». Det gikk
                                    masse tanker gjennom hodet, sier Eirik.{' '}
                                </Quote>
                                <Paragraph color="all-white">
                                    Bestemor Åshild står ved sofaen med telefonen i hånden. Hun er
                                    rolig på utsiden, men Sivert og Eirik legger merke til frykten
                                    og uroen i blikket hennes. Hun har allerede ringt 113 når
                                    barnebarna kommer stormende opp trappen.
                                </Paragraph>
                                <Paragraph color="all-white">
                                    Stemmen i telefonen prater rolig til henne og ber henne sette
                                    mobilen på høyttaler. Den medisinske operatøren i den andre
                                    enden har allerede trykket på den store røde knappen.
                                </Paragraph>
                            </Content>
                        </div>
                    </div>
                </Hero>

                <BannerImage
                    imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/10/olav-i-sykehusseng.jpg"
                    alt="Olav ligger i en seng på sykehuset med en oksygenmaske over ansiktet."
                >
                    <Content width="small">
                        <Paragraph color="all-black">
                            <b>
                                «Det er nå det gjelder» tenker Lasse. «Hvis vi ikke gjør ting riktig
                                nå, kan han dø. Nå må vi bare kjøre på.»
                            </b>
                        </Paragraph>
                    </Content>
                </BannerImage>

                <Section color="off-white">
                    {/* <StickyQRCTA
                        link="#stott-oss"
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/11/QR-kode-Gienjulegave-2024-1.png"
                        title="Støtt videreutvikling av det livreddende arbeidet"
                        orientation="left"
                    /> */}
                    <Content width="small">
                        <Paragraph>
                            Barnebarna forstår umiddelbart alvoret, og begynner å flytte på ting for
                            å lage bedre plass. De løfter bestefar ned på stuegulvet.
                        </Paragraph>
                        <Paragraph>
                            Lasse plasserer hendene midt på farens bryst og begynner med
                            hjertekompresjoner. Han presser rytmisk og med kraft, slik han lærte på
                            kurs for mange år siden ... 28 ... 29 ... 30. Eirik støtter bestefars
                            hode, og gir to innblåsinger.
                        </Paragraph>
                        <Paragraph>
                            Når Lasse blir sliten av kompresjonene overtar Sivert. De roterer med
                            jevne mellomrom for å porsjonere ut kreftene. De vet ikke hvor lenge de
                            må holde på, men de vet at han dør hvis de stopper.
                        </Paragraph>
                        <Video
                            src="https://player.vimeo.com/video/1025374418?autoplay=0&autopause=0&muted=0&loop=0&title=0&byline=0&portrait=0"
                            padding="177.78%"
                            height="500"
                            caption="Video: Se Sivert fortelle om det dramatiske øyeblikket da han måtte gjøre hjerte- og lungeredning på bestefar."
                        />
                        <Quote animation="fade-up" borderColor="primary">
                            – Jeg hadde en følelse av at han ikke var helt borte ennå, at det
                            fortsatt var litt liv i ham, sier Sivert.
                        </Quote>
                        <Paragraph>
                            Han har ganske nylig vært på hjerte- og lungeredningskurs på jobb, og
                            særlig én setning har brent seg fast.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – På kurset sa de at «hvis du er usikker på hva du skal gjøre, er det
                            bedre å begynne med hjertekompresjoner enn å ikke gjøre noe».
                        </Quote>
                        <Paragraph>
                            Sivert er så konsentrert på oppgaven at det tar en stund før han
                            registrerer stemmen fra telefonen som ligger på bordet.
                        </Paragraph>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/11/huset-til-olav-og-ashild-1.jpg"
                            alt="Huset til Olav og Åshild sett fra utsiden."
                            caption="Luftambulansen landet på den lille gresshaugen til høyre for huset til Olav og Åshild."
                        />
                        <Quote animation="fade-up" borderColor="primary">
                            – Dere gjør en kjempegod jobb. Nå er det 15 minutter til hjelpen er på
                            plass, sier den medisinske operatøren fra AMK-sentralen.
                        </Quote>
                        <Paragraph>
                            Fortsatt 15 lange minutter. Lasse, Eirik og Sivert finner en god rytme,
                            og samarbeider godt. Svetten renner, og hjertet hamrer. Olav er fortsatt
                            livløs.
                        </Paragraph>
                        <Paragraph>
                            Etter 17 minutter svinger det første av flere utrykningskjøretøy inn på
                            gårdsplassen. Ni minutter senere fylles rommet av rotorlyd.
                            Luftambulansen lander på en liten gresshaug rett utenfor stuevinduet. To
                            ambulanser, en legebil, en brannbil og et helikopter har rykket ut, og
                            stua er plutselig fylt med 12 fremmede mennesker.
                        </Paragraph>
                    </Content>
                    <FooterCTA
                        href="/kampanje/jul/gave/"
                        linkText="<b>Gi en gave</b><br/>Din støtte bidrar til å redde liv"
                        color="red"
                        bgColor="off-white"
                        textColor="all-white"
                        target="_blank"
                    />
                </Section>
                <Section color="off-white">
                    <BannerImage
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/11/olav-med-album-fra-sykehuset.jpg"
                        alt="Olav står i stuen sin med et album fra sykehuset i hånden."
                        caption="Olav fikk et album fra de ansatte på sykehuset, som beskriver behandlingen han har vært gjennom og viser bilder fra de første dagene etter hjertestansen."
                    />
                </Section>
                <Section color="off-white">
                    <Content width="small">
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            Når et hjerte slutter å slå
                        </Heading>
                        <Paragraph>
                            <b>Når et hjerte slutter å slå, haster det med riktig hjelp.</b>{' '}
                            Ambulansepersonellet som kommer opp trappen og inn i stua til Åshild og
                            Olav har med seg en hjertestarter.
                        </Paragraph>
                        <Paragraph>
                            De ber Lasse, Sivert og Eirik fortsette kompresjonene mens de gjør seg
                            klare. Så får de beskjed om å ta et skritt tilbake.
                        </Paragraph>
                        <Paragraph>
                            En ambulansearbeider følger dem ut i vinterhagen, slik at
                            redningsmannskapet får plass til å gjøre jobben sin. De river opp
                            skjorten og plasserer to elektroder på brystet til Olav. Den bleke,
                            livløse kroppen ligger stille mens hjerterytmen analyseres.
                        </Paragraph>
                        <Paragraph>
                            «Strømstøt anbefalt. Ikke rør pasienten», sier maskinen.
                        </Paragraph>
                        <Paragraph>Et sjokk sendes gjennom hjertet til Olav.</Paragraph>
                        <InlineCTA
                            type="accordion"
                            color="red"
                            buttonText="<b>Last ned Hjelp 113</b> - Se registrerte hjertestartere nær deg!"
                            link="/hjelp/"
                            target="_blank"
                        >
                            <details className="accordion" open>
                                <summary className="accordion-summary">
                                    <Heading
                                        type="h4"
                                        color="all-black"
                                        weight="600"
                                        className="no-margin"
                                    >
                                        Finn din nærmeste hjertestarter
                                    </Heading>
                                    <span className="material-symbols-outlined">
                                        keyboard_arrow_down
                                    </span>
                                </summary>
                                <ul>
                                    <li>
                                        Hvert år rammes nærmere 4000 mennesker av plutselig og
                                        uventet hjertestans i Norge. Mindre enn 15 prosent av de som
                                        får hjertestans utenfor sykehus overlever, ifølge tall fra
                                        det offentlige hjertestarterregisteret 113.no.
                                    </li>
                                    <li>
                                        67 prosent av de som fikk hjertestans i fjor var hjemme da
                                        det skjedde, ifølge tall fra Norsk hjertestartregister. I
                                        løpet av livet vil alle oppleve at en av deres nærmeste
                                        rammes av akutt sykdom eller ulykke.
                                    </li>
                                </ul>
                            </details>
                        </InlineCTA>
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            Lange minutter
                        </Heading>
                        <Paragraph>
                            Olavs kone, sønn og to barnebarn blir sittende i vinterhagen og se at
                            folk springer ut og inn av stua.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Det føltes som om vi så på en film, sier Lasse.{' '}
                        </Quote>
                        <Paragraph>
                            Eirik og Sivert går ut i hagen for å snakke med mannskapet fra
                            luftambulansen, og brannfolkene og ambulansearbeiderne som ikke er inne
                            hos Olav.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – De fortalte at vi hadde gjort alt riktig, og at vi ikke kunne ha gjort
                            mer. Det var betryggende å høre, forteller Eirik.
                        </Quote>
                        <Paragraph>
                            Han prøver å ta innover seg hva som akkurat har skjedd. Blodet bruser,
                            adrenalinet herjer i kroppen og han har tunnelsyn.
                        </Paragraph>
                        <Paragraph>Etter noen minutter kommer en av legene ut fra huset.</Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            <b>
                                – Olav er stabil. Forarbeidet dere har gjort er avgjørende for at
                                han har overlevd, sier luftambulanselege Christopher Bjerkvig.
                            </b>
                        </Quote>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/11/olav-og-ashild-pa-den-rode-sofaen.jpg"
                            alt="Olav og Åshild sitter på den vinrøde skinnsofaen i stuen hjemme."
                            caption="På denne sofaen lå Olav da hjertet hans sluttet å slå. Her sammen med kona Åshild, som var med på å redde livet hans."
                        />
                        <Paragraph>
                            Hjertet til Olav begynner å slå etter sjokket fra hjertestarteren, men
                            hjerterytmen er fortsatt ustabil. Han reagerer ikke når
                            ambulansepersonellet og legen snakker til ham.
                        </Paragraph>
                        <Paragraph>
                            Leppene hans er blå, kroppen er veldig urolig og det kommer surklete
                            fremmedlyder. Luftambulanselegen tar en{' '}
                            <FactPopup
                                factText="EKG (elektrokardiogram) er en medisinsk test som måler den elektriske aktiviteten i hjertet. Den registrerer hjertets rytme og kan oppdage unormal hjerteaktivitet, som for eksempel arytmier, hjerteinfarkt eller andre hjertesykdommer. EKG-resultatet vises som en grafisk kurve med bølger, som hjelper leger med å vurdere hjertets helse."
                                factTitle="EKG (elektrokardiogram)"
                                color="red"
                                textColor="all-white"
                            >
                                EKG
                            </FactPopup>{' '}
                            for å undersøke hjerterytmen hans.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Han har et stort hjerteinfarkt. Min vurdering er at vi må legge ham i
                            narkose på stedet. Vi intuberer ham, legger ham på respirator og gir ham
                            narkosemedisin og blodfortynnende medikamenter, forteller han.
                        </Quote>
                        <Paragraph>
                            Etter en stund kommer ambulansepersonellet bærende ut med Olav på båre.
                            Han er fortsatt bevisstløs og har et pusterør ned i lungene, for å sikre
                            frie luftveier. Det ser dramatisk ut.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            <b>
                                – Dette er veldig alvorlig. Det er ikke sikkert dette går bra, sier
                                Bjerkvig til familien.{' '}
                            </b>
                        </Quote>
                        <Paragraph>
                            Olav løftes inn i luftambulansen, som flyr til Haukeland
                            Universitetssjukehus.
                        </Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            Enda en hjertestans
                        </Heading>
                        <Paragraph>
                            På sykehuset får de vite at Olav har fått hjertestans igjen. Denne
                            gangen i helikopteret, da de landet på taket på sykehuset.
                        </Paragraph>
                        <Paragraph>
                            «Hvor lenge har pappa vært uten oksygen? Tre minutter? Fem minutter?
                            Ti?», tenker Lasse.
                        </Paragraph>
                        <Paragraph>
                            Nok en gang får han et støt fra en hjertestarter. På operasjonsbordet
                            åpner en annen lege den ene blodåren som forsyner hjertet med blod. Den
                            er tett, og det legges inn to stent. Deretter legges han i kunstig koma,
                            så kroppen skal få hvile.
                        </Paragraph>
                    </Content>
                </Section>
                <Section color="secondary" borderRadius="top">
                    <BannerImage
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/11/olav-sykehus-seng-2.jpg"
                        alt="Olav ligger i en seng på sykehuset"
                        spaceY={false}
                    >
                        <Content width="small">
                            <Paragraph color="all-black">
                                Synet som møter familien på sykehuset, minner om scener fra en
                                dramatisk TV-serie. Olav er koblet til masse slanger og ledninger.
                                Maskinene piper i en jevn rytme, og brystkassen hever og senker seg
                                ved hjelp av en respirator.
                            </Paragraph>
                        </Content>
                    </BannerImage>
                </Section>
                <Section color="secondary" borderRadius="bottom">
                    <div className="emergency-stripes">
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/02/akuttstriper-vertikal-gul.svg"
                            alt="Gule akuttstriper"
                            loading="lazy"
                        />
                    </div>
                    <StickyQRCTA
                        link="/kampanje/jul/gave/"
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/11/QR-kode-Gienjulegave-2024-1.png"
                        title="Støtt videreutvikling av det livreddende arbeidet"
                        orientation="right"
                        spaceY
                        target="_blank"
                    />
                    <Content width="small" spaceY spaceX>
                        <Paragraph color="all-white" className="no-margin">
                            Vil han våkne, og hvis han gjør det – hvem er han da?
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Hvis det er noen som overlever noe sånt, så er det bestefar, sier
                            Sivert. Han er skikkelig seig, og overlever det meste.
                        </Quote>
                        <Heading type="h3" weight="600" color="all-white">
                            Ingen smerter
                        </Heading>
                        <Paragraph color="all-white">Fire dager senere våkner Olav.</Paragraph>
                        <Paragraph color="all-white">
                            Den første han får øye på er barnebarnet Sivert. Han har ingen minner om
                            hva som har skjedd, men blir likevel ikke overrasket over å våkne på
                            sykehus.
                        </Paragraph>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/11/sivert-og-ashild-star-ved-sykesengen-1.jpg"
                            alt="Sivert og Åshild står ved sykesengen til Olav."
                            caption="Etter fire dager i koma våknet Olav, og den første han fikk øye på var barnebarnet Sivert. Her sammen med bestemor Åshild."
                            captionColor="all-white"
                        />
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Kroppen var smertefri. Jeg hadde ikke vondt noen steder. Jeg har aldri
                            kjent noen ting fra denne historien, så jeg har på en måte ikke vært med
                            på den. Det er en rar følelse. Ingen smerter da jeg lå på sofaen, ingen
                            smerter da jeg våknet på sykehuset fire dager senere, forteller Olav.
                        </Quote>
                        <Paragraph color="all-white">
                            Septemberdagen i 2023 startet som en helt vanlig dag. Overskyet vær,
                            rundt tolv grader. Perfekte forhold for å vaske båten.
                        </Paragraph>
                        <Paragraph color="all-white">
                            Etter å ha høytrykkspylt en stund, setter Olav seg i bilen og kjører
                            hjem. Han slenger seg nedpå sofaen, tar opp telefonen og ringer en
                            kamerat. De snakker vel og lenge. Så blir det mørkt.
                        </Paragraph>
                        <Paragraph color="all-white">
                            Åshild er på vei ut i hagen for å stelle med blomstene, og går
                            tilfeldigvis innom stua på veien ut. Der legger hun merke til at Olav er
                            blek i ansiktet.
                        </Paragraph>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/11/olav-i-sykeseng-med-en-sykepleier-ved-siden-av-1.jpg"
                            alt="Olav ligger i en sykeseng på sykehuset, med en sykepleier stående ved siden av sengen."
                            caption="Selv om Olavs kropp har vært gjennom store påkjenninger, står han selv fast på at han aldri har kjent på smerter, hverken før eller etter hjertestansen."
                            captionColor="all-white"
                        />
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg spurte om han ville ha et glass vann. Da jeg kom inn med
                            vannglasset fikk han ikke puste. Det kom en ralling fra brystet hans,
                            forteller hun, og fortsetter:
                        </Quote>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg skjønte umiddelbart hva som skjedde. Jeg har lest lignende
                            historier i Akuttmagasinet. Der sto det også at du må ta deg tid til å
                            ringe etter hjelp, og prøve å ikke få panikk. Derfor ringte jeg vår
                            eldste sønn Lasse, som er vår nærmeste nabo.
                        </Quote>
                        <Paragraph color="all-white">
                            <b>Resten er historie.</b>
                        </Paragraph>
                        <FooterCTA
                            href="/kampanje/jul/gave/"
                            linkText="<b>Gi en gave</b><br/>Din støtte bidrar til å redde liv"
                            color="red"
                            bgColor="off-white"
                            textColor="all-white"
                            target="_blank"
                        />
                    </Content>
                </Section>

                <BannerImage
                    imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/11/familien.jpg"
                    alt="Familien samlet foran huset."
                    caption="Liveredderfamilien: Fra venstre Olav Ståløy, sammen med sønnen Lasse, barnebarnet Eirik, kona Åshild og barnebarnet Sivert."
                    splitOnMobile
                />
                <Section color="off-white">
                    <Content width="small">
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            Dagen da alt klaffet
                        </Heading>
                        <Paragraph color="all-black">
                            <b>
                                Familien har tenkt mye på tilfeldighetene som spilte inn den dagen
                                hjertet til Olav sluttet å slå. Hva hadde skjedd dersom han sovnet
                                på sofaen før noen oppdaget ham? Hva om hjertet stoppet mens han var
                                alene i båten?
                            </b>
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            – Livet består av flaks og uflaks. Det gjelder ikke bare akkurat dette,
                            men andre ting også. Bare du skal ut og kjøre bil har du flaks om du
                            kommer hjem igjen, sier Olav.
                        </Quote>
                        <Quote animation="fade-up" color="secondary">
                            – Alt klaffet den dagen. At jeg var hjemom akkurat den lørdagen. At
                            Sivert ikke var ute med noen venner. At bestemor gikk innom stua på vei
                            ut i hagen. At pappa ikke var i garasjen da telefonen ringte, sier
                            Eirik.
                        </Quote>
                        <Paragraph>– Er det noe dere har tenkt på i ettertid?</Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            – Jeg har hatt det litt i bakhodet, men jeg prøver å ikke tenke så mye
                            på «timingen» av hele situasjonen. Alternativene er ikke noe jeg kan
                            eller burde tenke på, sier han.
                        </Quote>
                        <Quote animation="fade-up" color="secondary">
                            – Det er forferdelig å tenke på at det kunne gått skikkelig galt, så det
                            orker jeg ikke tenke på, sier Åshild.
                            <FixedCTA
                                color="snla-red"
                                text="<b>Vær<br /> bedre<br /> forberedt</b>"
                                buttonText="Last ned<br /><b>Hjelp 113</b><br />gratis"
                                icon="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-app-icon.png"
                                link="/hjelp/"
                                target="_blank"
                            />
                        </Quote>
                        <Paragraph>
                            Luftambulanselege Christopher Bjerkvig skryter av jobben som ble gjort
                            av Åshild, Lasse, Sivert og Eirik.
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            – Jeg er imponert over innsatsen de gjorde. Dette er utfallet når hele
                            den akuttmedisinske kjeden fungerer. Det første leddet er de som startet
                            hjerte- og lungeredning. De sørget for at vi andre hadde noe å bidra med
                            senere. Dette hadde ikke gått uten hjerte- og lungeredning i 17 minutter
                            før ambulansen kom. Det tåler man ikke, sier han.
                        </Quote>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/11/olav-og-barnebarna-pa-veien.jpg"
                            alt="Olav går tur med barnebarna Eirik og Sivert."
                            caption="Olav er en usedvanlig sprek 83-åring. Her sammen med barnebarna Sivert (t.v.) og Eirik."
                        />
                        <Paragraph>
                            For Lasse har det vært en tankevekker at livet er sårbart.{' '}
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            – Det var forferdelig å se pappa ligge der livløs og ikke vite om han
                            overlever. Det kunne fått et stygt utfall, der han enten ble veldig
                            skadet eller gikk bort. Det hadde også vært en dramatisk livsendring for
                            mor. Vi skal ta vare på hverdagene, sier Lasse, og legger til:
                        </Quote>
                        <Quote animation="fade-up" color="secondary">
                            – Vi har fått erfare at livet kan endre seg veldig fort. Vi skal ikke ta
                            ting for gitt, og vi må kanskje leve mer i nuet.
                        </Quote>
                        <Paragraph>
                            Olav er i dag friskmeldt, og er en aktiv 83-åring. Bare noen uker etter
                            hjertestansen, reiste han til Gran Canaria for å feire jul med familien.
                            Hit går ferden også i år.
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            <b>
                                – Jeg vil gi en oppriktig takk for livet til alle de som bidro til
                                at jeg fortsatt lever, sier han.
                            </b>
                        </Quote>
                    </Content>
                </Section>

                <Section color="off-white">
                    <Content width="large">
                        <Divider
                            color="secondary"
                            title="Støtt Stiftelsen Norsk Luftambulanse for en tryggere fremtid"
                        />
                        <SplitCTABox color="secondary" />
                        <VippsBanner />
                    </Content>
                </Section>

                <Section color="off-white">
                    <Content width="large">
                        <CTABlock
                            anchor="hjelp-113"
                            divider
                            color="secondary"
                            title="Det koster ingenting å være bedre forberedt"
                            innerTitle="Last ned Hjelp 113-appen"
                            appleGoogleStore
                            orientation="left"
                            imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-cta-bottom.jpg"
                            alt="Utviklingshelikopteret på øvelse"
                            bulletPoints={[
                                'Alle nødnumre på ett sted (110, 112 og 113)',
                                'Andre viktige numre som nærmeste legevakt og mental helse hjelpetelefon',
                                'Koordinatene der du befinner deg',
                                'Oversikt over hjertestartere i nærheten',
                                'Appen er gratis og har nå 2,6 millioner nedlastninger'
                            ]}
                        />
                    </Content>
                </Section>
            </div>
        </div>
    );
};

export default Olav;
